import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpload = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_620_3320",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_620_3320)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.21507 2H16.7849C17.4564 2 18 2.54363 18 3.21507C18 3.8865 17.4564 4.43014 16.7849 4.43014H3.21507C2.54363 4.43014 2 3.8865 2 3.21507C2 2.54363 2.54363 2 3.21507 2ZM9.02455 6.44538C9.64166 5.85154 10.3596 5.85154 10.9787 6.44538H10.9767C12.1841 7.6015 13.3916 8.75762 14.595 9.91768C15.1833 10.4839 15.1215 11.3342 14.4695 11.7781C13.9655 12.1214 13.3093 12.0662 12.8465 11.6302C12.4786 11.2834 12.1143 10.9319 11.75 10.5802C11.6459 10.4797 11.5417 10.3792 11.4374 10.2787C11.4048 10.2474 11.3767 10.2119 11.3483 10.1759C11.3337 10.1575 11.3191 10.139 11.3037 10.1209L11.2502 10.1446V10.3379C11.2502 11.0521 11.2505 11.7663 11.2507 12.4805C11.2512 13.9089 11.2516 15.3372 11.2502 16.7656C11.2502 17.4423 10.738 17.9691 10.0675 17.9987C9.33927 18.0302 8.75303 17.4936 8.75097 16.7814C8.7496 15.9278 8.75005 15.0742 8.75051 14.2206C8.75074 13.7938 8.75097 13.367 8.75097 12.9402V10.3359V10.0952C8.57065 10.2688 8.39521 10.4387 8.22274 10.6058C7.85809 10.9589 7.50672 11.2993 7.15061 11.6341C6.62401 12.1293 5.84235 12.1214 5.35072 11.6302C4.88378 11.1646 4.88172 10.4504 5.35278 9.97095C5.53709 9.78313 5.72845 9.60208 5.91981 9.42103C6.00183 9.34343 6.08384 9.26584 6.1653 9.18771C6.48272 8.88327 6.80015 8.5786 7.11765 8.27387C7.75278 7.66427 8.38821 7.05439 9.02455 6.44538Z"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgUpload);
export default ForwardRef;
